import { gql } from '@apollo/client';

export const CREATE_CLINIC_ACCOUNT = gql`
  mutation clinicSignUpFromSuperUser($input: ClinicSignUpFromSuperUserInput!) {
    clinicSignUpFromSuperUser(input: $input)
  }
`;

export const GET_ALL_TESTS = gql`
  query queryExcelChart {
    queryExcelChart {
      clinic {
        email
        name
      }
      patient {
        email
        name
        phone
        birth
        gender
        nationality
        nikOrPassport
        isPregnant
        menstrualDate
        memo
      }
      manager {
        name
        phone
      }
      test {
        code
        createdAt
        updatedAt
      }
    }
  }
`;
